import { render } from "./BlogCodeReview.vue?vue&type=template&id=410e86f8"
import script from "./BlogCodeReview.vue?vue&type=script&lang=js"
export * from "./BlogCodeReview.vue?vue&type=script&lang=js"

import "./BlogCodeReview.vue?vue&type=style&index=0&id=410e86f8&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__